module.exports = __webpack_public_path__ + "img/hospital.29675fcf.svg";